module.exports = __webpack_public_path__ + "static/img/m_faq_question_border@3x.3856f40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m_faq_question_border@3x.png
// module id = ZMvS
// module chunks = 1